export const featuredPortfolio = [
  {
    id: 1,
    title: "The Nobel Food",
    img:
      "./assets/project01.png",

    "imageUrl": "project1.png",
    "description": "A web application to connect Food donor to NGO/Volunteer and Person in need. \n A collaborative Hackathon project built by a team of 3 executed in 48 hours.\n Few features are Signup with password Hashing. Current Location capture. Data stored for individual user, Signup & Log-in Functionality verified by backend.\n",
    "techStack": "React js| MongoDb |Mongoose |Node js|Express.", "videoUrl": "#", "BlogUrl": "https://medium.com/@hello.shahanshah/", "link": "https://github.com/hello-snsa/The-Nobel-Food-server", "preview": "https://noblefood.netlify.app/", "techStackImage": "./tech/project02.png"



  },
  {
    id: 2,
    title: "LinkedIn Clone",
    img:
      "./assets/project02.png",

    "imageUrl": "project2.png", "title": "Linkedin",
    "description": "This is a clone of Linkedin website. \n A social media web application used for professional networking  and career development.\n Responsive pages. Signup page using mongoDB database. Login page using mongoDB database. Write new posts. Add connections. Chat with connections. Individual profile dashboard.\n",
    "techStack": "React js| MongoDb |Mongoose |Node js|Express |Bootstrap", "videoUrl": "#", "BlogUrl": "https://medium.com/@hello.shahanshah/linkedidn-clone-80cf6460894c", "link": "https://github.com/hello-snsa/linkedin-backend", "preview": "https://linkedin-clone2021.netlify.app/", "techStackImage": "./tech/project02.png"
  },
  {
    id: 3,
    title: "Indiegogo.com",
    img:
      "./assets/project03.png",

    "imageUrl": "project3.png",
    "description": "A web application which provide platform for Fund raising. \n This website will the people who have ideas but shoratge of money.\n Few features are Dual Navbar, Dual Interface, Dual Sign in - Sign up,Single-Page-Application, Accepting payment & Routing.\n",
    "techStack": "React, Bootstrap, HTML, CSS & JavaScript", "videoUrl": "#", "BlogUrl": "https://medium.com/@hello.shahanshah/cloning-indiegogo-c3830d081255", "link": "https://github.com/hello-snsa/indiegogo-clone", "preview": "https://indiegogo-clone.netlify.app/", "techStackImage": "./tech/project03.png"
  },
  {
    id: 4,
    title: "Cricket.com",
    img:
      "./assets/project04.png",

    "imageUrl": "project1.png",
    "description": "A web application to get all the details of a Cricket match. \n A collaborative project built by a team of 2 executed in 4 days.\n Few features are Fan Poll, Criclytics Page, Digest Data, Centre functional cards , Signup & Login Functionality\n",
    "techStack": " HTML, CSS & JavaScript", "videoUrl": "#", "BlogUrl": "https://medium.com/@hello.shahanshah/", "link": "https://github.com/hello-snsa/Cricket.com-Project", "preview": "https://hello-snsa.github.io/Cricket.com-Project/", "techStackImage": "./tech/project01.png"



  }



  //
  /*
  const data = [{
    "imageUrl": "project1.png", "title": "Urban Company",
    "description": "This is a clone of urban company website. \n This website is all about Service providing to the people who needs it.",
    "techStack": "React JS, BootStrap, Material UI, HTML, CSS & JavaScript", "videoUrl": "#", "BlogUrl": "https://medium.com/@vnts.srikanth/cloning-of-urban-companywebsite-e80651e78f00", "link": "https://github.com/srikanth-vnts/Urban_Company_Clone", "preview": "https://www.urbancompany.com/"
  },
  {
    "imageUrl": "project2.png", "title": "Cricket.com",
    "description": "A web application to get all the details of a Cricket match. \n This website is all about Cricket match and its aftermath.",
    "techStack": " HTML, CSS & JavaScript", "videoUrl": "#", "BlogUrl": "", "link": "https://github.com/hello-snsa/Cricket.com-Project", "preview": "https://hello-snsa.github.io/Cricket.com-Project/"
  },
  {
    "imageUrl": "project3.png", "title": "Indiegogo.com",
    "description": "A web application for Fund raising. \n This website is all about Fund Raising.",
    "techStack": "React, Bootstrap, HTML, CSS & JavaScript", "videoUrl": "#", "BlogUrl": "", "link": "https://github.com/hello-snsa/indiegogo-clone", "preview": "https://www.indiegogo.com/"
  }
  ]
  
  */
  // 












  // ,
  // {
  //   id: 5,
  //   title: "Hero Web Design",
  //   img:
  //     "https://cdn.dribbble.com/users/5031392/screenshots/15467520/media/c36b3b15b25b1e190d081abdbbf947cf.png?compress=1&resize=1200x900",
  // },
  // {
  //   id: 6,
  //   title: "Banking App",
  //   img:
  //     "https://cdn.dribbble.com/users/3307260/screenshots/15468444/media/447b4501f7a145b05e11c70199a9c417.jpg?compress=1&resize=1200x900",
  // },
];

export const webPortfolio = [
  {
    id: 1,
    title: "Web Social Media App",
    img: "https://cdn.dribbble.com/users/5031392/screenshots/15467520/media/c36b3b15b25b1e190d081abdbbf947cf.png?compress=1&resize=1200x900",
  },
  {
    id: 2,
    title: "Web Rampa UI Design",
    img: "https://cdn.dribbble.com/users/3967258/screenshots/15463803/media/4fddb9a2caf3b3bd634060f706a91e73.png?compress=1&resize=1200x900",
  },
  {
    id: 3,
    title: "Web E-commerce Design",
    img: "https://cdn.dribbble.com/users/3637068/screenshots/15467010/media/69a3279182b75365013fe285733d1122.png?compress=1&resize=1200x900",
  },
  {
    id: 4,
    title: "Web Relax App",
    img: "https://cdn.dribbble.com/users/2264844/screenshots/15463998/media/d85e92a332c41094f68e1f716884f7ce.jpg?compress=1&resize=1200x900",
  },
  {
    id: 5,
    title: "Web Design",
    img: "https://cdn.dribbble.com/users/387658/screenshots/15458608/media/e92ec1dd33dd1170ae3dc9c5272f2693.jpg?compress=1&resize=1200x900",
  },
  {
    id: 6,
    title: "Web Banking App",
    img: "https://cdn.dribbble.com/users/6384483/screenshots/15468426/media/ce9479fa1f8dba3a4a49840d76e55e31.png?compress=1&resize=1200x900",
  },
];

export const mobilePortfolio = [
  {
    id: 1,
    title: "Mobile Social Media App",
    img:
      "https://cdn.dribbble.com/users/2597268/screenshots/15468893/media/44313553d73ba41580f1df69749bba28.jpg?compress=1&resize=1200x900",
  },
  {
    id: 2,
    title: "Mobile Rampa UI Design",
    img:
      "https://cdn.dribbble.com/users/5920881/screenshots/15463142/media/b5a460223798bd85d835710806e2f3dd.png?compress=1&resize=1200x900",
  },
  {
    id: 3,
    title: "Mobile E-commerce Design",
    img:
      "https://cdn.dribbble.com/users/1998175/screenshots/15459384/media/48ac2b43ebe81ba0866afea1383cc939.png?compress=1&resize=1200x900",
  },
  {
    id: 4,
    title: "Mobile Relax App",
    img:
      "https://cdn.dribbble.com/users/2083704/screenshots/15468619/media/cd958306c7a772449e1ac23bd65ce506.png?compress=1&resize=1200x900",
  },
  {
    id: 5,
    title: "Mobile Hero Design",
    img:
      "https://cdn.dribbble.com/users/26642/screenshots/15462545/media/1a202ef5c8338b6f78634e6edc1ba350.png?compress=1&resize=1200x900",
  },
  {
    id: 6,
    title: "Mobile Banking App",
    img:
      "https://cdn.dribbble.com/users/1387827/screenshots/15466426/media/deb2dca6762cd3610321c98bfccb0b72.png?compress=1&resize=1200x900",
  },
];

export const designPortfolio = [
  {
    id: 1,
    title: "Design Social Media App",
    img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
  {
    id: 2,
    title: "Design Rampa UI Design",
    img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
  {
    id: 3,
    title: "Design E-commerce Web Design",
    img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
  {
    id: 4,
    title: "Design Relax Mobile App",
    img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
  {
    id: 5,
    title: "Design Keser Web Design",
    img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
  {
    id: 6,
    title: "Design Banking App",
    img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
];

export const contentPortfolio = [
  {
    id: 1,
    title: "Content Social Media App",
    img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
  {
    id: 2,
    title: "Content Rampa UI Design",
    img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
  {
    id: 3,
    title: "Content E-commerce Web Design",
    img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
  {
    id: 4,
    title: "Content Relax Mobile App",
    img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
  {
    id: 5,
    title: "Content Keser Web Design",
    img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
  {
    id: 6,
    title: "Content Banking App",
    img:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
  },
];
